<template>
  <div class="empty-container" v-if="help_style=='empty'">
    <img class="info-icon" src="../assets/img/info_tip.svg">
    <div class="info-text">
      <slot />
    </div>
  </div>
    <div class="alert-container" v-else-if="help_style=='alert'">
    <img class="alert-icon" src="../assets/img/alert.svg">
    <div class="alert-text">
      <slot />
    </div>
  </div>
  <div class="help-container" v-else>
    <img class="info-icon" src="../assets/img/info_tip.svg">
    <div class="info-text">
      <slot />
    </div>
  </div>
</template>

<script>
import SVGIcon from '@/components/SVGIcon.vue';
export default {
  name: 'HelpTip',
  components: {
    SVGIcon,
  },
  props: {
    help_style: {
      type: String,
      default: "",
    },
  },
};

</script>

<style lang="scss" scoped>

.info-icon {
    width: 18px;
    margin:2px;
    align-self: self-start;
}
.alert-icon {
    width: 18px;
    margin:2px;
    align-self: self-start;

}
.info-text {
    padding-left: 10px;
    color: rgb(11, 40, 91);
    text-align: left;
}

.alert-text {
    padding-left: 10px;
    color: rgb(121, 27, 27);
    text-align: left;
}

.help-container {
    display: flex;
    flex-direction: row;
    font-size: smaller;
    font-style: italic;
    border-radius: 6px;
    border: 1px solid rgb(198, 214, 228);
    background-color: var(--color-white-100);
    padding: 6px;
    width: fit-content;
    max-width: 800px;
}

.alert-container {

    fill:  rgb(121, 27, 27);
    display: flex;
    flex-direction: row;
    font-size: smaller;
    font-style: italic;
    border-radius: 6px;
    border: 1px solid rgb(198, 214, 228);
    background-color: rgb(245, 245, 172);
    padding: 6px;
    width: fit-content;
    max-width: 800px;
}

.empty-container {
    display: flex;
    flex-direction: row;
    margin-top: 4px ;
    margin-bottom: 4px ;
    font-size: smaller;
    font-style: italic;
    border-radius: 6px;
    border: 1px solid rgb(198, 214, 228);
    background-color: var(--color-white-100);
    padding: 6px;
    width: fit-content;
    max-width: 800px;
}
</style>
